import ProgramTransactionHistoryStoreProvider from './ProgramTransactionHistoryStoreProvider.js';

export default ProgramTransactionHistoryStoreProvider;
